import * as env from "../env";

export var inProgress = 0;
export var inProgressPost = 0;

function client(endpoint, { body, method, ...customConfig } = {}) {
  // console.log(process.env.REACT_APP_NOT_SECRET_CODE, env.API_URL);

  const token = window.localStorage.getItem("X-Admin-Token");
  const headers = {
    "Content-Type": "application/json",
    "X-Admin-Token": window.localStorage.getItem("X-Admin-Token"),
    "X-Auth-AdminID": window.localStorage.getItem("X-Auth-AdminID"),
    // "X-Admin-Token": "D3V3L0P3R$=ede4380597fc1ee169e9efcad68cb2c2",
    // "X-Auth-AdminID": 1,
    "Proxy-Connection": "keep-alive",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  let requestMethod = "GET";
  if (method) {
    requestMethod = method;
  } else if (body) {
    requestMethod = "POST";
  }

  if (
    env.READY_ONLY === true &&
    requestMethod !== "GET" &&
    !env.READY_ONLY_WHITELIST.includes(endpoint)
  ) {
    let promise = new Promise(function(resolve, reject) {
      setTimeout(
        () =>
          reject({
            _user_message: ["Application is running in readonly mode."],
            _user_message_type: "error",
          }),
        1000
      );
    });

    return promise;
  }

  if (inProgressPost > 0) {
    let promise = new Promise(function(resolve, reject) {
      setTimeout(
        () =>
          reject({
            _user_message: ["Request in progres."],
            _user_message_type: "error",
          }),
        1000
      );
    });

    return promise;
  }

  if (requestMethod !== "GET") {
    inProgressPost = inProgressPost + 1;
  }

  inProgress = inProgress + 1;
  const config = {
    method: requestMethod,
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };
  if (body) {
    config.body = JSON.stringify(body);
  }

  var url = env.API_URL;

  if (
    window.location.hostname.includes("dev") ||
    window.location.hostname.includes("localhost")
  ) {
    url = env.API_DEV_URL;
  } else if (window.location.hostname.includes("stage")) {
    url = env.API_STAGE_URL;
  }

  return window
    .fetch(`${url}/${endpoint}`, config)
    .then(async (response) => {
      inProgress = inProgress > 0 ? inProgress - 1 : 0;
      inProgressPost = inProgressPost > 0 ? inProgressPost - 1 : 0;

      if (response.status === 403) {
        window.location.assign("/401");
        return;
      } else if (response.status === 401) {
        window.location.assign("/401");
        return;
      }

      const data = await response.json();

      if (response.ok && response.status === 200) {
        return data;
      } else {
        return Promise.reject(data);
      }
    })
    .catch(async (response) => {
      inProgress = inProgress > 0 ? inProgress - 1 : 0;
      inProgressPost = inProgressPost > 0 ? inProgressPost - 1 : 0;

      // console.error(response);
      // const data = await response.json();
      return Promise.reject(response);
    });
}

export default client;
